import { useEffect } from 'react';
import { useNotification } from '../../components/Common/Notification/notify';
import { useTranslation } from 'react-i18next';

export default (error: string | null | undefined, force?: boolean): void => {
  const { t, i18n } = useTranslation();
  const notify = useNotification();
  useEffect(() => {
    if (error) {
      if (i18n.exists(error) || force) {
        notify.error(t(error));
      } else {
        notify.error(t('common.error'));
      }
    }
  }, [t, notify, error]);
};
